import * as React from "react";
import {AuthUserContext} from "./AuthUserContext";
import remergeCondition from "./conditions";
import {AppState} from "../store";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {createSelectCurrentUserWithCondition} from "../store/user/selectors";
import {IUser} from "../store/user/types";

interface IOwnProps {
}

interface IStateProps {
    authUser: IUser | null;
}

interface IDispatchProps {
}

type IProps = IOwnProps & IStateProps & IDispatchProps


const mapStateToProps = (state: AppState): IStateProps => ({
    authUser: createSelectCurrentUserWithCondition(state, remergeCondition)
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {};
};

export const withAuthentication = (Component: any) => {
    class WithAuthentication extends React.Component<IProps> {
        public render() {
            return (
                <AuthUserContext.Provider value={{authUser: this.props.authUser}}>
                    <Component/>
                </AuthUserContext.Provider>
            );
        }
    }

    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(WithAuthentication)
};